<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-10 19:58 -->
<!-- Description:  -->
<template>
  <div>
    <h4>LISTA DE USUARIOS</h4>
    <router-link class="btn btn-primary mb-3" :to="{ name: 'admin.user-create' }">
      Nuevo Usuario</router-link>
    <app-apirest-table
      :getList="AdminService.getUsers"
      ref="elApirestTable"
      v-slot:default="slotProps"
      >
      <thead>
        <tr>
          <th>#</th>
          <th>Nickname</th>
          <th>Email</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(l, i) in slotProps.list" :key="i">
          <td>{{ l.id }}</td>
          <td>{{ l.name }}</td>
          <td>{{ l.email }}</td>
          <td>
            <router-link class="btn btn-sm btn-light" :to="{ name: 'admin.user-permissions', params: { id: l.id }}">
              Permisos
            </router-link>
            <button class="btn btn-sm btn-danger" @click="deleteItem(l)">
              Eliminar 
            </button>
          </td>
        </tr>
      </tbody>
    </app-apirest-table>
  </div>
</template>
<script>
import AdminService from "../AdminService.js";

// script content
export default {
  name: "UserListView",
  components: {
    //
  },

  // directives

  props: {
    //
  },

  data: () => ({
    AdminService,
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    async deleteItem(item) {
      if( window.confirm("Eliminar registro?") ) {
        await AdminService.deleteUser(item.id);
        this.$refs.elApirestTable.reload();
      }
    }
    //
    //
  }
};
</script>
<style scoped></style>

